import { ref } from 'vue';
import { EntityItemQuery } from '@/services/api/resources/entityItem/query';
import { useTask } from '@/ui/concerns';
import { list as getEntityItemList } from '@/services/api/resources/entityItem';
import { sequence } from '@/ui/helpers';

export const useEntityItemCheck = () => {
  const checkLoading = ref<boolean>(true);
  const checkResult = ref<boolean>();

  const entityItemQuery = (): EntityItemQuery => ({
    search: '',
    sort: '',
    dir: '',
    entityType: [],
    entityFolder: [],
    user: [],
    page: 1,
    perPage: 1,
  });

  const performCheck = useTask(
    () => sequence(
      getEntityItemList(entityItemQuery()),
    ),
    ([
      listResponse,
    ]) => {
      checkResult.value = listResponse.data.length > 0;
      checkLoading.value = false;
    },
  );

  return {
    checkLoading,
    checkResult,
    performCheck,
  };
};
